import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";

@Component({
  selector: "app-verifyuniqueid",
  templateUrl: "./verifyuniqueid.component.html",
  styleUrls: ["./verifyuniqueid.component.scss"],
})
export class VerifyuniqueidComponent implements OnInit {
  apiUrl: string;
  dtOptions: any = {};
  submitted = false;

  outboundForm: FormGroup;
  uniqueForm: FormGroup;
  testDetails: any;
  passportNumber: any;
  travelType: any;
  uniqueId: string;
  inboundForm: FormGroup;
  modalOptions: NgbModalOptions;
  closeResult: string;
  modalRef: any;
  danger: boolean = false;
  collectionCenters: any;
  lgas: any;
  status: any;
  today: any;
  validityDate: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}
  ngOnInit() {
    this.modalOptions = {
      backdrop: true,
      centered: true,
      backdropClass: "customBackdrop",
      size: "lg",
    };
    this.inituniqueForm();
    this.today = new Date();
    console.log(this.today);
  }

  inituniqueForm() {
    this.uniqueForm = this.formBuilder.group({
      uniqueId: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9]*$"), Validators.minLength(11)]],
    });
  }

  viewModal(modal) {
    this.showModal(modal);
  }

  submitForm(formData) {
    this.submitted = true;
    this.testDetails = "";
    if (this.uniqueForm.invalid) {
      return;
    }

    this.getUserDetails();
    this.submitted = false;
  }

  getUserDetails() {
    this.uniqueId = this.uniqueForm.get("uniqueId").value;
    let obj = {
      ctms_passenger_id: this.uniqueId,
    };
    this.testDetails = null;
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "passenger-get-record-airport";

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, obj, { headers: reqHeader })
      .subscribe((data) => {
        console.log("userDetails: ", data);
        if (data.status == true) {
          this.testDetails = data.response;
          this.validityDate = this.testDetails.validity_date;

          // let dateArr = this.validityDate.split("-");
          // this.validityDate = dateArr[1] + "/" + dateArr[2] + "/" + dateArr[0];
          // // console.log("today  ",this.today)
          // this.validityDate = new Date(this.validityDate);
          // // console.log("validity  ",this.validityDate)
          // const diffTime = Math.abs(this.today - this.validityDate);
          // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          // // console.log("diffdays  ",diffDays)
          // // console.log("difftime  ",diffTime)
          // if (this.today > this.validityDate || diffDays > 3) {
          //   this.status = "Invalid";
          // } else {
          //   this.status = "Valid";
          // }

          this.status = this.testDetails.status;
          this.travelType = data.response.type;
          this.spinnerService.hide();

          if (this.testDetails.test_result && this.testDetails.test_result.toLowerCase() == "positive") {
            this.danger = true;
          } else if (this.testDetails.test_result && this.testDetails.test_result.toLowerCase() == "negative") {
            this.danger = false;
          }
          document.getElementById("loadModal").click();
        } else {
          Swal.fire({
            icon: "error",
            title: "",
            text:
              data.response != null ? data.response[0].message : data.message,
            showConfirmButton: true,
            timer: 4000,
          });
          this.spinnerService.hide();
        }
      });
  }

  confirmResult(id, status) {
    const obj = {
      id: id,
      status: status,
    };

    this.spinnerService.show();
    this.apiUrl =
      environment.AUTHAPIURL + "airport_personnel_passenger/authenticate";

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, obj, { headers: reqHeader })
      .subscribe((data) => {
        // console.log("userDetails: ", data);
        if (data.status == true) {
          this.spinnerService.hide();
          Swal.fire({
            icon: "info",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 4000,
          });
          document.getElementById("closeModal").click();
        } else {
          Swal.fire({
            icon: "info",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 6000,
          });
          this.spinnerService.hide();
        }
      });
  }

  showModal(modal) {
    this.modalService.open(modal, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
